import script from "./BaseInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseInput.vue?vue&type=script&lang=ts&setup=true"

import "./BaseInput.vue?vue&type=style&index=0&id=f7459f5e&lang=css"

const __exports__ = script;

export default __exports__